import * as actions from 'appRedux/actions/taxInvoice/taxInvoiceActionType';
import { TaxInvoiceResponse } from 'routes/main/taxInvoice/types';

export interface TaxInvoiceState {
  loader: boolean;
  dataSource: any[];
  paging: {
    current: number;
    limit: number;
    total_rows: number;
    row_count: number;
  } | null;
  error: string | null;
  process: {
    status: boolean;
    action: string;
    message: string;
  };
}

const initialState: TaxInvoiceState = {
  loader: false,
  dataSource: [],
  paging: null,
  error: null,
  process: {
    status: false,
    action: '',
    message: '',
  },
};

export default (
  state: TaxInvoiceState = initialState,
  action: actions.TaxInvoiceAction
): TaxInvoiceState => {
  switch (action.type) {
    case actions.TAX_INVOICE_REQUEST:
      return {
        ...state,
        loader: true,
        error: null,
        process: {
          status: false,
          action: 'taxInvoiceRequest',
          message: '',
        },
      };

    case actions.TAX_INVOICE_SUCCESS: {
      const response: TaxInvoiceResponse = action.payload;
      const items = response.data?.result_data?.items || [];
      const paging = response.data?.result_data?.paging || null;

      return {
        ...state,
        loader: false,
        dataSource: items,
        paging,
        error: null,
        process: {
          status: true,
          action: 'taxInvoiceRequest',
          message: response.data?.result_msg || 'Success',
        },
      };
    }

    case actions.TAX_INVOICE_ERROR:
      return {
        ...state,
        loader: false,
        error: action.payload.message,
        process: {
          status: false,
          action: 'taxInvoiceRequest',
          message: action.payload.message,
        },
      };

    case actions.TAX_INVOICE_RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
